<template>
	<div class="row border border-warning mx-2 py-1 my-2">
		<div class="form-group col-sm-8">
			<BaseMultiSelect
				@change:value="getCities"
				@update:value="setCity"
				:options="multiSelectState.options"
				:defaultData="cityObj?.id"
				rules="required"
				:name="`City ${nameIndex + 1}`"
				mode="single"
				@valError="inputError"
				@valSuccess="inputSuccess"
			/>
		</div>
		<div class="form-group col-sm-4 position-relative">
			<BaseInput
				name="stayNights"
				label="Night Stay"
				type="number"
				v-model="state.stayNights"
				class="form-control form-control-lg dashInput"
				:required="true"
				rules="required"
				@valError="inputError"
				@valSuccess="inputSuccess"
			/>
			<span
				v-if="state.id !== 1"
				@click="clickHandler(state.id)"
				class="mx-2 position-absolute top-90 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer"
				><i class="bi bi-x"></i
			></span>
		</div>
	</div>
</template>
<script>
	import { reactive, watch } from "vue";
	import FormCheck from "@/helpers/formCheckHelper";
	import Helper from "@/helpers/dataHelper";
	import BaseInput from "./BaseInput";
	import BaseMultiSelect from "./BaseMultiSelect";

	export default {
		name: "CityStay",
		components: {
			BaseInput,
			BaseMultiSelect,
		},
		props: {
			id: {
				type: Number,
				default: 1,
			},
			country: {
				type: [String, Boolean],
				default: false,
			},
			nameIndex: {
				type: Number,
				default: 0,
			},
			cityObj: {
				type: [Object],
				default: { id: null, name: null },
			},
			stayCount: {
				type: [Number],
				default: 1,
			},
		},
		emits: [
			"addComponent",
			"removeComponent",
			"inputError",
			"inputSuccess",
			"updateData",
			"removeId",
		],
		setup: (props, { emit }) => {
			const state = reactive({
				id: 0,
				city: {
					id: 0,
					name: null,
					state_name: null,
				},
				stayNights: 0,
			});

			const nullable = [];

			const multiSelectState = reactive({
				cities: [],
				options: [],
			});

			const clickHandler = (id) => {
				emit("removeComponent", id);
			};

			state.id = props.id;
			if (props.stayCount) {
				state.stayNights = props.stayCount;
			}
			if (Object.values(props.cityObj).length) {
				state.city.name = props.cityObj.name;
				state.city.id = props.cityObj.id;

				multiSelectState.options = [
					{
						label: props.cityObj.name,
						value: props.cityObj.id,
					},
				];
				multiSelectState.cities = [
					{
						id: props.cityObj.id,
						name: props.cityObj.name,
					},
				];
			}

			// ! City Functions

			const getCities = async (cityObj = false) => {
				let data = {};
				if (!cityObj && !props.country) return;
				if (!cityObj?.name && props.country) {
					data.countryName = props.country;
				}
				if (cityObj?.name && cityObj?.name.length < 3) return;
				if (cityObj?.name) data.name = cityObj.name;
				if (cityObj?.country) data.countryName = cityObj?.country;
				try {
					const cities = await Helper.getCities(data);

					if (Object.values(props.cityObj).length) {
						multiSelectState.cities = [
							{
								id: props.cityObj.id,
								name: props.cityObj.name,
								state_name: props.cityObj.state_name,
							},
							...cities,
						];
					} else multiSelectState.cities = cities;

					const changeFormat = cities.map((city) => {
						return {
							label: `${city.name} (${city.state_name})`,
							value: city.id,
						};
					});

					if (Object.values(props.cityObj).length) {
						multiSelectState.options = [
							{
								label: props.cityObj.name,
								value: props.cityObj.id,
							},
							...changeFormat,
						];
					} else multiSelectState.options = [...changeFormat];
				} catch (error) {
					console.log(error);
				}
			};
			watch(
				() => props.country,
				(newValue, prevValue) => {
					getCities();
				},
			);

			getCities();

			const setCity = (dataObj) => {
				if (!dataObj) {
					state.city.id = 0;
					state.city.name = null;
					state.city.state_name = null;
					return;
				}
				// ? finding selected city data
				const city = multiSelectState.cities.filter(
					(city) => city.id === dataObj,
				);
				state.city.id = city[0].id;
				state.city.name = city[0].name;
				state.city.state_name = city[0].state_name;
			};

			watch(
				() => state,
				(newValue, preValue) => {
					try {
						if (state.city.name && parseInt(state.stayNights, 10)) {
							//if (props.cityObj.id) emit("removeId", props.cityObj.id);
							return emit("updateData", {
								...state,
								stayNights: parseInt(state.stayNights, 10),
							});
						}
						return;
					} catch (error) {
						console.log(error);
					}
					
				},
				{
					deep: true,
				},
			);

			// event handler for input validation event
			const inputError = (input) => {
				// const check = FormCheck.valError(input, state, nullable);
				// return emit("inputError", check);
			};

			const inputSuccess = (input) => {
				// const check = FormCheck.valSuccess(input, state, nullable);
				// return emit("inputSuccess", check);
			};

			return {
				state,
				multiSelectState,
				clickHandler,
				getCities,
				setCity,
				inputError,
				inputSuccess,
			};
		},
	};
</script>
